<template>
  <div class="tw-bg-gray-100 tw-relative tw-p-0">
    <div class="tw-flex tw-flex-col tw-items-center tw-justify-center tw-mx-auto">
      <transition name="component-fade" mode="out-in">
        <keep-alive>
          <component
            :isLoading="isLoading"
            :is="component"
            :businessId="businessId"
            :businessName="businessName"
            :primaryColor="primaryColor"
            :secondaryColor="secondaryColor"
            :operatingModel="operatingModel"
            :email="email"
            :location="location"
            :businessPlans="businessPlans"
            :selectedPlans="selectedPlans"
            :filteredBusinessPlans="filteredBusinessPlans"
            :collectAddressSetting="collectAddressSetting"
            :collectDobSetting="collectDobSetting"
            @signupSelection="signupSelection"
            @filterPlans="filterPlans"
            @signIn="isUser = true"
          ></component>
        </keep-alive>
      </transition>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "MemberLocationWebSignupView",
  components: {
    Plans: () => import("@/views/business/business-member-signup/components/Plans"),
    SignIn: () => import("@/views/business/business-member-signup/components/SignIn"),
    MemberLocationSignUp: () => import("@/views/business/business-member-signup/location-signup/components/MemberLocationSignUp"),
    MemberLocationPayment: () => import("@/views/business/business-member-signup/location-signup/components/MemberLocationPayment"),
  },
  props: {
    businessId: String,
    businessLocationId: String,
  },
  data() {
    return {
      isLoading: false,
      primaryColor: null,
      secondaryColor: null,
      operatingModel: null,
      businessName: null,
      email: null,
      isUser: false,
      location: {},
      businessPlans: [],
      filteredBusinessPlans: [],
      selectedPlans: [],
      collectAddressSetting: false,
      collectDobSetting: false,
    };
  },
  computed: {
    ...mapGetters("cognito", ["isAuthenticated"]),
    component() {
      if (this.selectedPlans.length === 0) return "Plans";
      if (!this.isAuthenticated && this.isUser) return "SignIn";
      if (!this.isAuthenticated && !this.isUser) return "MemberLocationSignUp";
      if (this.isAuthenticated) return "MemberLocationPayment";

      return "Plans";
    },
  },
  created() {
    this.isLoading = true;
    this.email = this.$route.query.e;
    this.isUser = this.$route.query.u === "true";

    this.$axios
      .get(`/businesses/${this.businessId}/locations/${this.businessLocationId}/member-location-web-signup`)
      .then((res) => {
        this.businessName = res.data.businessName;
        this.primaryColor = res.data.primaryColor;
        this.secondaryColor = res.data.secondaryColor;
        this.operatingModel = res.data.operatingModel;
        this.businessPlans = res.data.plans;
        this.location = res.data.location;
        this.collectAddressSetting = res.data.collectAddressSetting;
        this.collectDobSetting = res.data.collectDobSetting;
      })
      .catch((err) => {
        this.EventBus.$emit("GLOBAL_ERROR", {
          title: "Failed to load plans",
          message: "We had a problem retrieving the list of plans. Please reload the page to try again.",
          error: err,
        });
      })
      .finally(() => {
        this.isLoading = false;
      });
  },
  watch: {
    component: function() {
      window.scrollTo(0, 0);
    },
  },
  methods: {
    signupSelection(selectedPlans) {
      this.selectedPlans = selectedPlans;
    },
    filterPlans(group) {
      this.filteredBusinessPlans = this.businessPlans.filter((plan) => plan.planGroup === group).sort((a, b) => a.sortOrder - b.sortOrder);
    },
  },
};
</script>
